//import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { TimeInOutThisWeek } from './TimeInOutThisWeek';
import { TimeLateThisWeek } from './TimeLateThisWeek';
import { TimeVacationLeave } from './TimeVacationLeave';
import { TimeSickDay } from './TimeSickDay';
//import { TimeInOutInfo } from "../../pages/TimeInOutInfo";
import { useTranslation } from 'react-i18next';
import { ProfileType } from '../../../model/datatype';
import { useNavigate, useParams } from 'react-router-dom';
import { getTimeInOutLastMonth } from '../../../services/ApiGetTimeInOut';
import { getLateInfo } from '../../../services/ApiGetLateThisWeek';
import { getVacationLeave } from '../../../services/ApiGetVacationLeave';
import { getSickDay } from '../../../services/ApiGetSickDay';

const TABS = ['active1', 'active2', 'active3', 'active4'];

export const TimeInOut = (props: any) => {
  let { t } = useTranslation();
  let navigate = useNavigate();
  // The tab comes from the URL (/time_in_out/active1..4), so a card clicked on the home page, a refresh
  // and a bookmark all open the right list.
  const { id } = useParams();
  const isHome = props.renderBxo === 'none';
  const tabFromUrl = id && TABS.includes(id) ? id : 'active1';
  const [active, setActive] = useState(isHome ? '' : tabFromUrl);
  const [data] = useState<ProfileType | null>(JSON.parse(sessionStorage.getItem('obj_user_info') || '{}'));

  useEffect(() => {
    if (!isHome) setActive(tabFromUrl);
  }, [isHome, tabFromUrl]);

  // Load attendance in the background so a card or tab shows its list at once. On the home page only the
  // time in/out list (the slowest, ~1.2 s) is fetched, a moment after the page has loaded; on the attendance
  // page all four are. Answers are cached for a few minutes (cachedRequest), so this does not repeat per click.
  useEffect(() => {
    if (!data?.email) return;
    const ignore = () => undefined;
    if (isHome) {
      const timer = setTimeout(() => getTimeInOutLastMonth(data.email).catch(ignore), 1500);
      return () => clearTimeout(timer);
    }
    getTimeInOutLastMonth(data.email).catch(ignore);
    getLateInfo(0, 0, data.email).catch(ignore);
    getVacationLeave(0, 0, data.email).catch(ignore);
    getSickDay(0, 0, data.email).catch(ignore);
  }, [isHome, data?.email]);

  let HomeCheck = true;
  if (!isHome) {
    HomeCheck = false;
  }

  const handleClick = (tab: string) => {
    setActive(tab);
    navigate('/time_in_out/' + tab, { state: tab });
  };

  let statusActive1 = '';
  let statusActive2 = '';
  let statusActive3 = '';
  let statusActive4 = '';
  switch (active) {
    case 'active1':
      statusActive1 = 'active1';
      break;
    case 'active2':
      statusActive2 = 'active2';
      break;
    case 'active3':
      statusActive3 = 'active3';
      break;
    case 'active4':
      statusActive4 = 'active4';
      break;
  }

  return (
    <>
      {!HomeCheck ? (
        <>
          <div className="time-detail-box">
            <Container>
              <Row className="m-auto">
                <Col className=" px-1">
                  <div
                    cy-id="box-1"
                    className={
                      'attendance-card time-detail-box-in-out time-in-out-box ' + statusActive1
                    }
                    onClick={() => handleClick('active1')}
                  >
                    <p className="time-detail-title">
                      {data?.totalTimeInOut}{' '}
                      {t('time_list_box.timeanddate_in_out.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_in_out')}
                    </p>
                    <img
                      src="../images/time_in_out.svg"
                      className="time-detail-img-left"
                      alt="time in out"
                    />
                  </div>
                </Col>
                <Col className=" px-1">
                  <div
                    cy-id="box-2"
                    className={
                      'attendance-card time-detail-box-last-this-week time-in-out-box ' +
                      statusActive2
                    }
                    onClick={() => handleClick('active2')}
                  >
                    <p className="time-detail-title">
                      {data?.totalLates}{' '}
                      {t('time_list_box.timeanddate_late_this_week.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_late_this_week')}
                    </p>
                    <img
                      src="../images/laste_this_week.png"
                      width={52}
                      className="time-detail-img-right"
                      alt="last this week"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="m-auto">
                <Col className=" px-1 mt-3">
                  <div
                    cy-id="box-3"
                    className={'attendance-card time-detail-box-in-out ' + statusActive3}
                    onClick={() => handleClick('active3')}
                  >
                    <p className="time-detail-title">
                      {data?.remainVacations}{' '}
                      {t('time_list_box.timeanddate_vacation_leave.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_vacation_leave')}
                    </p>
                    <img
                      src="../images/vacation_leave.svg"
                      className="time-detail-img-left"
                      alt="vacation leave"
                    />
                  </div>
                </Col>
                <Col className=" px-1 mt-3">
                  <div
                    cy-id="box-4"
                    className={
                      'attendance-card time-detail-box-stick-this-week ' + statusActive4
                    }
                    onClick={() => handleClick('active4')}
                  >
                    <p className="time-detail-title">
                      {data?.totalSickDays}{' '}
                      {t('time_list_box.timeanddate_sick.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_sick_days')}
                    </p>
                    <img
                      src="../images/sick_day.png"
                      width={52}
                      className="time-detail-img-right"
                      alt="sick day"
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <div className="time-detail-box">
          <Container>
            <Row className="m-auto">
              <Col className=" px-0">
                <div
                  cy-id="box-1"
                  className={
                    'attendance-card time-detail-box-in-out time-in-out-box ' + statusActive1
                  }
                  onClick={() => handleClick('active1')}
                >
                  <p className="time-detail-title">
                    {data?.totalTimeInOut}{' '}
                    {t('time_list_box.timeanddate_in_out.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_in_out')}
                  </p>
                  <img
                    src="../images/time_in_out.svg"
                    className="time-detail-img-left"
                    alt="time in out"
                  />
                </div>
              </Col>
              <Col className=" px-0">
                <div
                  cy-id="box-2"
                  className={
                    'attendance-card time-detail-box-last-this-week time-in-out-box ' +
                    statusActive2
                  }
                  onClick={() => handleClick('active2')}
                >
                  <p className="time-detail-title">
                    {data?.totalLates}{' '}
                    {t('time_list_box.timeanddate_late_this_week.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_late_this_week')}
                  </p>
                  <img
                    src="../images/laste_this_week.png"
                    width={52}
                    className="time-detail-img-right"
                    alt="last this week"
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-auto">
              <Col className=" px-0 mt-3">
                <div
                  cy-id="box-3"
                  className={'attendance-card time-detail-box-in-out ' + statusActive3}
                  onClick={() => handleClick('active3')}
                >
                  <p className="time-detail-title">
                    {data?.remainVacations}{' '}
                    {t('time_list_box.timeanddate_vacation_leave.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_vacation_leave')}
                  </p>
                  <img
                    src="../images/vacation_leave.svg"
                    className="time-detail-img-left"
                    alt="vacation leave"
                  />
                </div>
              </Col>
              <Col className=" px-0 mt-3">
                <div
                  cy-id="box-4"
                  className={'attendance-card time-detail-box-stick-this-week ' + statusActive4}
                  onClick={() => handleClick('active4')}
                >
                  <p className="time-detail-title">
                    {data?.totalSickDays}{' '}
                    {t('time_list_box.timeanddate_sick.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_sick_days')}
                  </p>
                  <img
                    src="../images/sick_day.png"
                    width={52}
                    className="time-detail-img-right"
                    alt="sick day"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {!HomeCheck ? (
        (() => {
          switch (active) {
            case 'active1':
              return <TimeInOutThisWeek email={data?.email} />;
            case 'active2':
              return <TimeLateThisWeek email={data?.email} />;
            case 'active3':
              return <TimeVacationLeave email={data?.email} />;
            case 'active4':
              return <TimeSickDay email={data?.email} />;
            default:
              if (props.renderBxo !== 'none') {
                return <TimeInOutThisWeek email={data?.email} />;
              }
          }
        })()
      ) : (
        <></>
      )}
    </>
  );
};
